export default __webpack_public_path__ + "static/media/luca.5ec629cc.webp";